<!-- =========================================================================================
    File Name: KnowledgeBase.vue
    Description: Knowledge Base Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="knowledge-base-page">
        <div class="knowledge_base_wrap">
          <div class="knowledge_base_filters">
            <div class="knowledge_base_filters_cnt">
              <div class="search">
                <input type="text" placeholder="Search" >
              </div>
              <h4>Filter By</h4>
              <div class="knowledge_filters_cnt">
                <h6>Type</h6>
                <ul class="centerx">
                  <li>
                    <vs-checkbox v-model="checkBox1">Answers</vs-checkbox>
                  </li>
                  <li>
                    <vs-checkbox v-model="checkBox2">Errata</vs-checkbox>
                  </li>
                  <li>
                    <vs-checkbox v-model="checkBox3">How-To</vs-checkbox>
                  </li>  
                </ul>
              </div>
              <div class="knowledge_filters_cnt">
                <h6>KDB Area</h6>
                <ul class="centerx">
                  <li>
                    <vs-checkbox v-model="checkBox1">Component</vs-checkbox>
                  </li>
                  <li>
                    <vs-checkbox v-model="checkBox2">DSP</vs-checkbox>
                  </li>
                  <li>
                    <vs-checkbox v-model="checkBox3">Development Kits</vs-checkbox>
                  </li>
                  <li>
                    <vs-checkbox v-model="checkBox3">Programmable Acceleration Cards</vs-checkbox>
                  </li>  
                </ul>
              </div>
            </div>
          </div>
          <div class="knowledge_base_cnt">
            <div class="knowledge_base_list">
              <label>Why is the Agilex I2C Controller Interface HPS I/O Pins are not Bidirectional in Platform Designer?</label>
              <p>Due to a problem in the Intel® Quartus® Prime Pro Edition software version 20.2 and earlier, you may not be able to change the Intel® Agilex™ I2C Controller Interface HPS I/O Pins to bidirectional in Platform Designer....</p>
            </div>
            <div class="knowledge_base_list">
              <label>Why does the FPGA to SoC Bridge not work in my Intel Agilex SoC Design?</label>
              <p>Due to a problem in the Intel® Quartus® Prime Pro Edition Software version 20.3 and later, the FPGA to SOC bridge may not work correctly on Intel® Agilex® Engineering Sample (ES) devices. ...</p>
            </div>
            <div class="knowledge_base_list">
              <label>Why is the Agilex I2C Controller Interface HPS I/O Pins are not Bidirectional in Platform Designer?</label>
              <p>Due to a problem in the Intel® Quartus® Prime Pro Edition software version 20.2 and earlier, you may not be able to change the Intel® Agilex™ I2C Controller Interface HPS I/O Pins to bidirectional in Platform Designer....</p>
            </div>
            <div class="knowledge_base_list">
              <label>Why does the FPGA to SoC Bridge not work in my Intel Agilex SoC Design?</label>
              <p>Due to a problem in the Intel® Quartus® Prime Pro Edition Software version 20.3 and later, the FPGA to SOC bridge may not work correctly on Intel® Agilex® Engineering Sample (ES) devices. ...</p>
            </div>
            <div class="knowledge_base_list">
              <label>Why is the Agilex I2C Controller Interface HPS I/O Pins are not Bidirectional in Platform Designer?</label>
              <p>Due to a problem in the Intel® Quartus® Prime Pro Edition software version 20.2 and earlier, you may not be able to change the Intel® Agilex™ I2C Controller Interface HPS I/O Pins to bidirectional in Platform Designer....</p>
            </div>
            <div class="knowledge_base_list">
              <label>Why does the FPGA to SoC Bridge not work in my Intel Agilex SoC Design?</label>
              <p>Due to a problem in the Intel® Quartus® Prime Pro Edition Software version 20.3 and later, the FPGA to SOC bridge may not work correctly on Intel® Agilex® Engineering Sample (ES) devices. ...</p>
            </div>
            <div class="knowledge_base_list">
              <label>Why is the Agilex I2C Controller Interface HPS I/O Pins are not Bidirectional in Platform Designer?</label>
              <p>Due to a problem in the Intel® Quartus® Prime Pro Edition software version 20.2 and earlier, you may not be able to change the Intel® Agilex™ I2C Controller Interface HPS I/O Pins to bidirectional in Platform Designer....</p>
            </div>
            <div class="knowledge_base_list">
              <label>Why does the FPGA to SoC Bridge not work in my Intel Agilex SoC Design?</label>
              <p>Due to a problem in the Intel® Quartus® Prime Pro Edition Software version 20.3 and later, the FPGA to SOC bridge may not work correctly on Intel® Agilex® Engineering Sample (ES) devices. ...</p>
            </div>
          </div>
        </div>         
    </div>
</template>

<script>

export default{
  data () {
    return {
       
      
    }
  },
  computed: {
     
  },
  methods: {},
  components: {}
}
</script>

<style lang="scss">
.knowledge-base-jumbotron-content {
    background-image: url('../../assets/images/pages/knowledge-base-cover.jpg');
    background-size: cover;
}
</style>
